import {
  emptyString,
  successMessages,
  managersConstants,
} from "../../constants";
import { customToast } from "../../../../shared";
import { managersService } from "../../services";
import {
  success,
  withSpinner,
  failure,
} from "../../../../redux/actions/utilities";
import {
  toastTypes,
  userPermissionsConstants,
} from "../../../shared-screens/constants";

const {
  MANAGERS_DATA,
  RESET_MANAGERS,
  UPDATE_MANAGERS,
  MANAGERS_DETAIL,
  GET_ALL_LOCATIONS,
  MANAGERS_UPDATED_FLAG,
} = managersConstants;
const { REMOVED_SUCCESSFULLY, UPDATED_SUCCESSFULLY } = successMessages;

const { GROUP } = userPermissionsConstants;

//Fetching paginated managers data by brand id
const getManagersByBrandId = (queryString, brandId) => {
  return (dispatch) => {
    withSpinner(dispatch, MANAGERS_DATA, () =>
      managersService
        .getManagersByBrandId(queryString, brandId)
        .then(
          (response) => {
            dispatch(success(response, MANAGERS_DATA));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

//Fetching paginated managers data by group id
const getManagersByGroupId = (queryString, groupId) => {
  return (dispatch) => {
    withSpinner(dispatch, MANAGERS_DATA, () =>
      managersService
        .getManagersByGroupId(queryString, groupId)
        .then(
          (response) => {
            dispatch(success(response, MANAGERS_DATA));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

//Delete Manager on the basis of ID
const deleteManager = (managerId, queryString, brandId, userRole) => {
  return (dispatch) => {
    return withSpinner(dispatch, MANAGERS_DATA, () =>
      managersService
        .deleteManager(managerId)
        .then(
          (_response) => {
            customToast(REMOVED_SUCCESSFULLY, toastTypes.SUCCESS);
            dispatch(emptyAllManagers());
            if (userRole === GROUP) {
              dispatch(getManagersByGroupId(queryString, brandId));
            } else {
              dispatch(getManagersByBrandId(queryString, brandId));
            }
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
            throw error;
          }
        )
    );
  };
};

//Function to update manager details
const updateManagerDetails = (body, gridState, groupId, userRole) => {
  return (dispatch) => {
    withSpinner(dispatch, MANAGERS_DATA, () =>
      managersService
        .updateManagerDetails(body)
        .then(
          (_response) => {
            customToast(UPDATED_SUCCESSFULLY, toastTypes.SUCCESS);
            dispatch(success(true, MANAGERS_UPDATED_FLAG));
            dispatch(getManagerDetails(body.groupId));
            dispatch(emptyAllManagers());
            if (userRole === GROUP) {
              dispatch(getManagersByGroupId(gridState, groupId));
            } else {
              dispatch(getManagersByBrandId(gridState, body.brandId));
            }
            dispatch(resetUpdateManager());
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

//Empty all managers from redux
const emptyAllManagers = () => {
  return (dispatch) => dispatch(success([], RESET_MANAGERS));
};

//Fetching manager details
const getManagerDetails = (managerId) => {
  return (dispatch) => {
    withSpinner(dispatch, MANAGERS_DETAIL, () =>
      managersService
        .getManagerDetails(managerId)
        .then(
          (response) => {
            dispatch(success(response || [], MANAGERS_DETAIL));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

const resetUpdateManager = () => (dispatch) => {
  dispatch(failure(emptyString, UPDATE_MANAGERS));
};

//Function to remove brand location from manager
const removeManagerLocation = (
  managerLocationId,
  managerId,
  queryString,
  brandId,
  userRole
) => {
  return (dispatch) => {
    return withSpinner(dispatch, MANAGERS_DATA, () =>
      managersService
        .removeManagerLocation(managerLocationId, managerId)
        .then(
          (_response) => {
            customToast(REMOVED_SUCCESSFULLY, toastTypes.SUCCESS);
            dispatch(emptyAllManagers());
            if (userRole === GROUP) {
              dispatch(getManagersByGroupId(queryString, brandId));
            } else {
              dispatch(getManagersByBrandId(queryString, brandId));
            }
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
            throw error;
          }
        )
    );
  };
};

//Fetching brandlocation for managers by group id
const getBrandlocations = (groupId) => {
  return (dispatch) => {
    withSpinner(dispatch, MANAGERS_DATA, () =>
      managersService
        .getBrandlocations(groupId)
        .then(
          (response) => {
            dispatch(success(response, GET_ALL_LOCATIONS));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

//Exporting functions for other files
export const managersActions = {
  deleteManager,
  emptyAllManagers,
  getManagerDetails,
  getBrandlocations,
  resetUpdateManager,
  updateManagerDetails,
  getManagersByBrandId,
  removeManagerLocation,
  getManagersByGroupId,
};
